import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Button } from "./Button";
import { BRAND, NAV_LINKS } from "@/content/site";
import { cn } from "@/lib/cn";
import logoUrl from "@/assets/logo-djinious-lab.png";

export function Nav() {
  // Translucent over the hero at the very top; solid (border + shadow) once
  // scrolled. Initial state matches the prerendered top-of-page (no hydration
  // mismatch); the effect syncs to the real scroll position on mount.
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={cn(
        "sticky top-0 z-30 backdrop-blur-md transition-colors duration-300",
        scrolled
          ? "border-b border-border/70 bg-background/90 shadow-sm"
          : "border-b border-transparent bg-background/40",
      )}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2.5" aria-label={BRAND}>
          <img src={logoUrl} alt="" className="h-8 w-8" width={32} height={32} />
          <span className="text-lg font-extrabold tracking-tight text-foreground">{BRAND}</span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-2">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                cn(
                  "rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground",
                  isActive && "text-foreground",
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Button to="/book-demo" className="ml-1 px-4 py-2">Book a demo</Button>
        </div>
      </nav>
    </header>
  );
}
